import { render, staticRenderFns } from "./singleBindAdminDialog.vue?vue&type=template&id=dfc46670&"
import script from "./singleBindAdminDialog.vue?vue&type=script&lang=js&"
export * from "./singleBindAdminDialog.vue?vue&type=script&lang=js&"
import style0 from "./singleBindAdminDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports